/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Photo_InvalidInputs */

const en_profile_photo_invalid = /** @type {(inputs: Profile_Photo_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a valid JPEG, PNG or WebP image.`)
};

const pt_br2_profile_photo_invalid = /** @type {(inputs: Profile_Photo_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma imagem JPEG, PNG ou WebP válida.`)
};

/**
* | output |
* | --- |
* | "Choose a valid JPEG, PNG or WebP image." |
*
* @param {Profile_Photo_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_photo_invalid = /** @type {((inputs?: Profile_Photo_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Photo_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_photo_invalid(inputs)
	return pt_br2_profile_photo_invalid(inputs)
});